import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import {
  OrderListingPage,
  CustomersPage,
  ProductsPage,
  AdminBeatListPage,
  AdminCategoryPage,
  NoSaleCatSubCatPage,

} from '../model/page.model';
import { environment } from 'src/environments/environment';
import { List } from '../model/list.model';
import { Data } from '../model/data.model';
import {
  AdminOrder,
  AdminOrderDetails,
  Products,
  TypeList,
} from '../model/admin.order.model';
import { StatusList } from '../model/status-list.model';
import {
  CustomerAddress,
  CustomerDetails,
  EmailChange,
  PhoneChange,
} from '../model/customer-details.model';
import {
  AddProduct,
  Product,
  ProductList,
  ProductName,
  ProductType,
} from '../model/product.model';
import { User } from '../model/user-details.model';
import { AddBanner, Banner } from '../model/banner.model';
import { AdminBeatAdd, AdminBeatList } from '../model/b2b/orders/master/beatMaster';
import { AddUpdateSubAdminData, SubAdminDetailById, SubAdminList } from '../model/subdmin.model';
import { PrivilegesMenu } from '../model/adminPrivilegesList.model';
import { NoSaleCatSubCat, NoSaleCatSubCatAdd } from '../model/b2b/orders/master/no-sale-cat-subcat';
import { DdlModel, GodownAddr } from '../model/ddl.model';
import { GstSlab } from '../model/b2b/orders/master/gst-slab';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  constructor(private http: HttpClient) { }

  getAllCustomers(page: CustomersPage): Observable<Data<List<User>>> {
    return this.http.post<Data<List<User>>>(
      `${environment.apiURL}/AdminCustomer/GetAllUserData`,
      page
    );
  }
  getAllOrders(
    requestData: OrderListingPage
  ): Observable<Data<List<AdminOrder>>> {
    return this.http.post<Data<List<AdminOrder>>>(
      `${environment.apiURL}/AdminOrder/allOrders`,
      requestData
    );
  }
  getOrderStatusList(): Observable<Data<StatusList[]>> {
    return this.http.get<Data<StatusList[]>>(
      `${environment.apiURL}/getDashBoardOrderstatusList`
    );
  }

  deactivateCustomer(obj: any): Observable<Data<any>> {
    return this.http.post<Data<any>>(
      `${environment.apiURL}/AdminCustomer/DeactivateUser`,
      obj
    );
  }

  activateCustomer(obj: any): Observable<Data<any>> {
    return this.http.post<Data<any>>(
      `${environment.apiURL}/AdminCustomer/ActivateUser`,
      obj
    );
  }
  getOrderDetailsById(id: string): Observable<Data<AdminOrderDetails[]>> {
    return this.http.post<Data<AdminOrderDetails[]>>(
      `${environment.apiURL}/AdminOrder/orderDetailsById`,
      { orderId: id }
    );
  }
  getProductDropdown(): Observable<Data<Products[]>> {
    return this.http.get<Data<Products[]>>(
      `${environment.apiURL}/GetProductNameDropDown`
    );
  }
  getTypeDropdown(): Observable<Data<TypeList[]>> {
    return this.http.get<Data<TypeList[]>>(
      `${environment.apiURL}/GetSubCategory`
    );
  }


  getCategory(): Observable<Data<List<ProductType>>> {
    return this.http.post<Data<List<ProductType>>>(
      `${environment.apiURL}/AdminCategory/GetCategory`, {
      "pageNo": 1,
      "pageSize": 100
    }
    );
  }

  gstMasterDdl(): Observable<Data<DdlModel[]>> {
    return this.http.get<Data<DdlModel[]>>(`${environment.apiURL}/api/v1/B2B/Admin/GstMasterDdl`);
  }

  addCustomer(obj: any): Observable<Data<any>> {
    return this.http.post<Data<any>>(
      `${environment.apiURL}/AdminCustomer/AddNewCustomer`,
      obj
    );
  }

  getCustomerDetails(obj: any): Observable<Data<CustomerDetails[]>> {
    return this.http.post<Data<CustomerDetails[]>>(
      `${environment.apiURL}/AdminCustomer/UserDetailsById`,
      obj
    );
  }

  getCustomerAddressList(obj: any): Observable<Data<CustomerAddress[]>> {
    return this.http.post<Data<CustomerAddress[]>>(
      `${environment.apiURL}/AdminCustomer/AddressListByUserId`,
      obj
    );
  }

  updateCustomerAddresses(obj: any): Observable<Data<any>> {
    return this.http.put<Data<any>>(
      `${environment.apiURL}/AdminCustomer/UpdateCustomerAddresses`,
      obj
    );
  }

  updateCustomerPhone(obj: PhoneChange): Observable<Data<any>> {
    return this.http.put<Data<any>>(
      `${environment.apiURL}/AdminCustomer/UpdateCustomerMobile`,
      obj
    );
  }

  updateCustomerEmail(obj: EmailChange): Observable<Data<any>> {
    return this.http.put<Data<any>>(
      `${environment.apiURL}/AdminCustomer/UpdateCustomerEmail`,
      obj
    );
  }

  addNewAddress(obj: any): Observable<Data<any>> {
    return this.http.post<Data<any>>(
      `${environment.apiURL}/AdminCustomer/AddCustomerAddress`,
      obj
    );
  }

  updateCustomerName(obj: any): Observable<Data<any>> {
    return this.http.put<Data<any>>(
      `${environment.apiURL}/AdminCustomer/UpdateCustomerName`,
      obj
    );
  }
  updateOrderContacts(obj: any): Observable<Data<any>> {
    return this.http.put<Data<any>>(
      `${environment.apiURL}/AdminOrder/EditContactPerson`,
      obj
    );
  }
  updateOrderAddress(obj: any): Observable<Data<any>> {
    return this.http.put<Data<any>>(
      `${environment.apiURL}/AdminOrder/UpdateShippingAddress`,
      obj
    );
  }
  updateOrderStatus(obj: any): Observable<any> {
    return this.http.put<Data<any>>(
      `${environment.apiURL}/AdminOrder/updateOrderStatus`,
      obj
    );
  }

  getAllProducts(page: ProductsPage): Observable<Data<List<ProductList>>> {
    return this.http.post<Data<List<ProductList>>>(
      `${environment.apiURL}/AdminProduct/AdminProductListing`,
      page
    );
  }

  getProductNameDropdown(): Observable<Data<ProductName[]>> {
    return this.http.get<Data<ProductName[]>>(
      `${environment.apiURL}/GetProductNameDropDown`
    );
  }

  getProductTypeDropdown(): Observable<Data<ProductType[]>> {
    return this.http.get<Data<ProductType[]>>(
      `${environment.apiURL}/GetSubCategory`
    );
  }

  getSubCategoryByCatId(catId: number): Observable<Data<ProductType[]>> {

    return this.http.get<Data<ProductType[]>>(
      `${environment.apiURL}/GetSubCategoryByCatId/${catId}`
    );
  }
  getSubCategoryByCatIdArr(catIdArr: number[]): Observable<Data<ProductType[]>> {
    return this.http.post<Data<ProductType[]>>(`${environment.apiURL}/Admin/getSubCategoryByCatIdArr`, catIdArr);
  }


  addProduct(formData: FormData): Observable<Data<any>> {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': `${environment.apiURL}`,
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Access-Control-Allow-Headers': 'origin,X-Requested-With,content-type,accept',
      'Access-Control-Allow-Credentials': 'true'
    });
    return this.http.post<Data<any>>(`${environment.apiURL}/AdminProduct/AddProduct`, formData, { headers: headers });
  }

  addSubCategory(obj: any): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/AdminSubCategory/AddSubCategory`, obj);
  }

  updateSubCategory(obj: any): Observable<Data<any>> {
    return this.http.put<Data<any>>(`${environment.apiURL}/AdminSubCategory/UpdateSubCategory`, obj);
  }

  deleteSubCategory(obj: any): Observable<Data<any>> {
    return this.http.delete<Data<any>>(`${environment.apiURL}/AdminSubCategory/DeleteSubCategory`, { body: obj })
  }

  addCategory(obj: any): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/AdminCategory/AddCategory`, obj);
  }

  UpdateCategory(obj: any): Observable<Data<any>> {
    return this.http.put<Data<any>>(`${environment.apiURL}/AdminCategory/UpdateCategory`, obj);
  }

  deleteCategory(obj: any): Observable<Data<any>> {
    return this.http.delete<Data<any>>(`${environment.apiURL}/AdminCategory/deleteCategory`, { body: obj })
  }

  getProductById(obj: any): Observable<Data<Product[]>> {
    return this.http.post<Data<Product[]>>(
      `${environment.apiURL}/AdminProduct/productDetailById`, obj
    );
  }

  deleteProductImage(obj: any): Observable<Data<any>> {
    return this.http.delete<Data<any>>(
      `${environment.apiURL}/AdminProduct/DeleteProductImage`, { body: obj }
    );
  }
  deleteProductVideo(obj: any): Observable<Data<any>> {
    return this.http.delete<Data<any>>(
      `${environment.apiURL}/AdminProduct/DeleteProductVideo`, { body: obj }
    );
  }

  addProductImage(formData: FormData): Observable<Data<AddProduct[]>> {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': `${environment.apiURL}`,
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Access-Control-Allow-Headers': 'origin,X-Requested-With,content-type,accept',
      'Access-Control-Allow-Credentials': 'true'
    });
    return this.http.post<Data<AddProduct[]>>(
      `${environment.apiURL}/AdminProduct/AddProductImage`, formData, { headers: headers }
    );
  }

  updateProduct(obj: any): Observable<Data<any>> {
    return this.http.put<Data<any>>(
      `${environment.apiURL}/AdminProduct/UpdateProduct`, obj
    );
  }

  updateProductVideo(obj: any): Observable<Data<any>> {

    return this.http.post<Data<any>>(
      `${environment.apiURL}/AdminProduct/UpdateProductVideo`, obj
    );
  }

  updateVideoThumbnail(obj: any): Observable<Data<any>> {

    return this.http.post<Data<any>>(
      `${environment.apiURL}/AdminProduct/UpdateVideoThumbnail`, obj
    );
  }

  deleteProduct(obj: any): Observable<Data<any>> {
    return this.http.delete<Data<any>>(
      `${environment.apiURL}/AdminProduct/DeleteProduct`, { body: obj }
    );
  }

  existingAdminGoogleLogin(access_token: string): Observable<any> {
    return this.http.post(`${environment.apiURL}/AdminUser/ExistingAdminGoogleLogin`, { key: access_token })
  }

  addCompanyForFreeTrial(obj: Object): Observable<any> {
    return this.http.post(`${environment.apiURL}/AdminUser/AddCompanyForFreeTrial`, obj)
  }

  adminLogin(obj: Object): Observable<any> {
    return this.http.post(`${environment.apiURL}/AdminUser/AdminLogin`, obj).pipe(
      catchError(this.handleError)
    )
  }

  adminForgotPassword(obj: Object): Observable<any> {
    return this.http.post(`${environment.apiURL}/AdminUser/AdminForgotPassword`, obj).pipe(
      catchError(this.handleError)
    )
  }

  varifyEmail(obj: Object): Observable<any> {
    return this.http.post(`${environment.apiURL}/AdminUser/VarifyEmail`, obj).pipe(
      catchError(this.handleError)
    )
  }

  resetPassword(obj: Object): Observable<any> {
    return this.http.post(`${environment.apiURL}/AdminUser/ResetPassword`, obj).pipe(
      catchError(this.handleError)
    )
  }

  private handleError(err: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    }
    else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;

    }
    return throwError(() => errorMessage);
  }
  getBannerData(): Observable<Data<Banner[]>> {
    return this.http.get<Data<Banner[]>>(
      `${environment.apiURL}/Product/GetBannerData`
    );
  }
  addBannerImage(formData: FormData): Observable<Data<AddBanner[]>> {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': `${environment.apiURL}`,
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Access-Control-Allow-Headers': 'origin,X-Requested-With,content-type,accept',
      'Access-Control-Allow-Credentials': 'true'
    });
    return this.http.post<Data<AddBanner[]>>(
      `${environment.apiURL}/AdminProduct/AddBannerImage`, formData, { headers: headers }
    );
  }
  deleteBannerImage(obj: any): Observable<Data<any>> {
    return this.http.delete<Data<any>>(
      `${environment.apiURL}/AdminProduct/DeleteBanner`, { body: obj }
    );
  }
  updateBannerData(obj: any): Observable<Data<any>> {
    return this.http.put<Data<any>>(
      `${environment.apiURL}/AdminProduct/UpdateBannerData`, obj
    );
  }

  getAllContactUsData(obj: any): Observable<Data<any>> {
    return this.http.post<Data<any>>(
      `${environment.apiURL}/ContactUs/AdminGetAllContactUsData`, obj);
  }

  getContactById(id: any): Observable<Data<any>> {
    return this.http.post<Data<any>>(
      `${environment.apiURL}/ContactUs/AdminGetContactById`, id).pipe(
        catchError(this.handleError)
      )
  }

  adminBlogListing(obj: any): Observable<Data<any>> {

    return this.http.post<Data<any>>(
      `${environment.apiURL}/Blog/AdminBlogListing`, obj).pipe(
        catchError(this.handleError)
      )
  }

  addBlog(formData: FormData): Observable<Data<any>> {

    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': `${environment.apiURL}`,
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Access-Control-Allow-Headers': 'origin,X-Requested-With,content-type,accept',
      'Access-Control-Allow-Credentials': 'true'
    });
    return this.http.post<Data<AddBanner[]>>(
      `${environment.apiURL}/Blog/AdminAddBlog`, formData, { headers: headers })
  }

  deleteBlog(blogId: object): Observable<any> {
    return this.http.delete<any>(`${environment.apiURL}/Blog/AdminDeleteBlog`, { body: blogId }).pipe(
      catchError(this.handleError)
    )
  }
  adminGetBlogById(blogId: object): Observable<Data<any>> {

    return this.http.post<Data<any>>(`${environment.apiURL}/Blog/AdminGetBlogById`, blogId).pipe(
      catchError(this.handleError)
    )
  }

  updateBlog(updatedBlog: any): Observable<Data<any>> {
    return this.http.put<Data<any>>(`${environment.apiURL}/Blog/AdminUpdateBlog`, updatedBlog).pipe(
      catchError(this.handleError)
    )
  }

  updateBlogVisibility(updateBlogVisibility: any): Observable<Data<any>> {
    return this.http.put<Data<any>>(`${environment.apiURL}/Blog/AdminBlogVisibility`, updateBlogVisibility).pipe(
      catchError(this.handleError)
    )
  }

  updateBlogImage(formData: FormData): Observable<any> {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': `${environment.apiURL}`,
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Access-Control-Allow-Headers': 'origin,X-Requested-With,content-type,accept',
      'Access-Control-Allow-Credentials': 'true'
    });
    return this.http.put<any>(
      `${environment.apiURL}/Blog/AdminUpdateBlogImage`, formData, { headers: headers }
    );
  }

  getAdminDataById(): Observable<Data<any>> {
    return this.http.get<Data<any>>(`${environment.apiURL}/AdminUser/GetAdminDataById`).pipe(
      catchError(this.handleError)
    )
  }

  updateAdminName(name: Object): Observable<Data<any>> {
    return this.http.put<Data<any>>(`${environment.apiURL}/AdminUser/UpdateAdminName`, name).pipe(
      catchError(this.handleError)
    )
  }

  updateAdminEmail(email: Object): Observable<Data<any>> {
    return this.http.put<Data<any>>(`${environment.apiURL}/AdminUser/UpdateAdminEmail`, email).pipe(
      catchError(this.handleError)
    )
  }

  adminChangePassword(password: Object): Observable<Data<any>> {
    return this.http.put<Data<any>>(`${environment.apiURL}/AdminUser/AdminChangePassword`, password).pipe(
      catchError(this.handleError)
    )
  }

  checkAdminEmailOtp(email: Object): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/AdminUser/CheckAdminEmailOtp`, email).pipe(
      catchError(this.handleError)
    )
  }

  adminSendEmailOtp(email: Object): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/AdminUser/AdminSendEmailOtp`, email).pipe(
      catchError(this.handleError)
    )
  }

  subadminList(data: any, isWarehouse: boolean): Observable<Data<List<SubAdminList>>> {
    return this.http.post<Data<List<SubAdminList>>>(`${environment.apiURL}/AdminUser/SubAdminList/${isWarehouse}`, data)
  }

  wareHouseList(data: any): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/AdminUser/WareHouseList`, data)
  }

  godownDdlbyMId(): Observable<Data<GodownAddr[]>> {
    return this.http.get<Data<GodownAddr[]>>(`${environment.apiURL}/api/v1/B2B/Admin/GodownDdlbyMId`)
  }

  addSubAdmin(data: AddUpdateSubAdminData): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/AdminUser/AddSubAdminNew`, data)
  }

  addWareHouseManager(data: AddUpdateSubAdminData): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/AdminUser/AddWareHouseManager`, data)
  }

  subAdminDetailById(userId: number): Observable<Data<SubAdminDetailById>> {
    return this.http.post<Data<SubAdminDetailById>>(`${environment.apiURL}/AdminUser/SubAdminDetailById`, { "userId": userId })
  }
  userPermissionByRoleId(permissionId: number): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/AdminUser/UserPermissionByRoleId`, { "roleId": permissionId })
  }

  updateSubAdmin(data: AddUpdateSubAdminData): Observable<Data<any>> {
    return this.http.put<Data<any>>(`${environment.apiURL}/AdminUser/UpdateSubAdminNew`, data)
  }

  updateWareHouseManager(data: AddUpdateSubAdminData): Observable<Data<any>> {
    return this.http.put<Data<any>>(`${environment.apiURL}/AdminUser/UpdateWareHouseManager`, data)
  }

  deleteSubAdmin(obj: any): Observable<Data<any>> {
    return this.http.delete<Data<any>>(`${environment.apiURL}/AdminUser/DeleteSubAdmin`, { body: obj })
  }

  adminDashBoardOrdersData(): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/AdminDashBoardOrdersData`, null)
  }

  getSalesWisePerformance(catId: number, year: number): Observable<any> {
    return this.http.post<any>(`${environment.apiURL}/api/v1/B2B/admin/SalesPerformanceWithFilter/${catId}/${year}`, null)
  }

  zoneWiseRevenue(year: number, month: number): Observable<Data<any>> {
    return this.http.get<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/ZoneWiseRevenue/${year}/${month}`)
  }

  getCatWisePerformance(): Observable<Data<any>> {
    return this.http.get<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/GetCategorySalesAsync`)
  }

  getSubCatWisePerformance(catId: number): Observable<Data<any>> {
    return this.http.get<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/GetSubCatSalesAsync/${catId}`)
  }

  getAdminZoneList(obj: AdminBeatListPage): Observable<Data<List<AdminBeatList>>> {
    return this.http.post<Data<List<AdminBeatList>>>(`${environment.apiURL}/api/v1/B2B/admin/ZoneList`, obj)
  }

  zoneAdd(obj: AdminBeatAdd): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/ZoneAdd`, obj)
  }

  zoneUpdate(obj: AdminBeatAdd): Observable<Data<any>> {
    return this.http.put<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/ZoneUpdate`, obj)
  }

  deleteZone(zoneId: number): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/ZoneDelete?StateId=${zoneId}`, null)
  }

  getAdminStateList(obj: AdminBeatListPage): Observable<Data<List<AdminBeatList>>> {
    return this.http.post<Data<List<AdminBeatList>>>(`${environment.apiURL}/api/v1/B2B/admin/GetAdminStateList`, obj)
  }

  stateAdd(obj: AdminBeatAdd): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/StateAdd`, obj)
  }

  stateUpdate(obj: AdminBeatAdd): Observable<Data<any>> {
    return this.http.put<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/StateUpdate`, obj)
  }

  deleteState(obj: any): Observable<Data<any>> {
    return this.http.delete<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/DeleteState`, { body: obj })
  }

  getAdminCityList(obj: AdminBeatListPage): Observable<Data<List<AdminBeatList>>> {
    return this.http.post<Data<List<AdminBeatList>>>(`${environment.apiURL}/api/v1/B2B/admin/GetAdminCityList`, obj)
  }

  cityAdd(obj: AdminBeatAdd): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/CityAdd`, obj)
  }

  cityUpdate(obj: AdminBeatAdd): Observable<Data<any>> {
    return this.http.put<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/CityUpdate`, obj)
  }

  deleteCity(obj: any): Observable<Data<any>> {
    return this.http.delete<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/DeleteCity`, { body: obj })
  }

  getAdminBeatList(obj: AdminBeatListPage): Observable<Data<List<AdminBeatList>>> {
    return this.http.post<Data<List<AdminBeatList>>>(`${environment.apiURL}/api/v1/B2B/admin/GetAdminBeatList`, obj)
  }

  addBeatMaster(obj: any): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/AddBeatMaster`, obj)
  }

  updateBeatMaster(obj: AdminBeatAdd): Observable<Data<any>> {
    return this.http.put<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/UpdateBeatMaster`, obj)
  }

  deleteBeat(obj: any): Observable<Data<any>> {
    return this.http.delete<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/DeleteBeat`, { body: obj })
  }

  getCategoryListAdmin(obj: AdminCategoryPage): Observable<Data<List<any>>> {
    return this.http.post<Data<List<any>>>(`${environment.apiURL}/AdminCategory/getCategoryListAdmin`, obj)
  }

  getSubCategoryListAdmin(obj: AdminCategoryPage): Observable<Data<List<any>>> {
    return this.http.post<Data<List<any>>>(`${environment.apiURL}/AdminSubCategory/getSubCategoryListAdmin`, obj)
  }

  getGstSlabListAdmin(obj: AdminCategoryPage): Observable<Data<List<GstSlab>>> {
    return this.http.post<Data<List<any>>>(`${environment.apiURL}/api/v1/B2B/admin/GstSlablList`, obj)
  }

  addGstSlab(obj: GstSlab): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/CreateGstSlab`, obj);
  }

  deleteGstSLab(gstSlabId: number): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/DeleteGstSlab/${gstSlabId}`, null)
  }

  updateGstSlab(obj: GstSlab): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/UpdateGstSlab`, obj);
  }

  getNoSaleCatList(obj: NoSaleCatSubCatPage): Observable<Data<List<NoSaleCatSubCat>>> {
    return this.http.post<Data<List<NoSaleCatSubCat>>>(`${environment.apiURL}/api/v1/B2B/admin/NoSaleCatList`, obj)
  }

  addNoSaleCat(obj: NoSaleCatSubCatAdd): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/AddNoSaleCat`, obj)
  }

  updateNoSaleCat(obj: NoSaleCatSubCatAdd): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/NoSaleCatUpdate`, obj)
  }

  deleteNoSaleCat(noSaleCatId: number): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/NoSaleCatDelete`, { 'subCatId': noSaleCatId })
  }

  getNoSaleSubCatList(obj: NoSaleCatSubCatPage): Observable<Data<List<NoSaleCatSubCat>>> {
    return this.http.post<Data<List<NoSaleCatSubCat>>>(`${environment.apiURL}/api/v1/B2B/admin/NoSaleSubCatList`, obj)
  }

  addNoSaleSubCat(obj: NoSaleCatSubCatAdd): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/AddNoSaleSubCat`, obj)
  }

  updateNoSaleSubCat(obj: NoSaleCatSubCatAdd): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/UpdateNoSaleSubCat`, obj)
  }

  deleteNoSaleSubCat(noSaleCatId: number): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/api/v1/B2B/admin/NoSaleSubCatDelete`, { 'subCatId': noSaleCatId })
  }

  getMenuList(): Observable<Data<any>> {
    return this.http.get<Data<any>>(`${environment.apiURL}/AdminUser/MenuList`)
  }

  getMenuActions(): Observable<Data<PrivilegesMenu[]>> {
    return this.http.get<Data<PrivilegesMenu[]>>(`${environment.apiURL}/AdminUser/MenuActions`)
  }

  getCompanyPermission(): Observable<Data<any>> {
    return this.http.get<Data<any>>(`${environment.apiURL}/api/v1/B2B/Admin/CompanyPermission`)
  }

  sendPhoneOtp(phone: string) {
    return this.http.post<Data<PrivilegesMenu[]>>(`${environment.apiURL}/AdminUser/SendB2BUsersPhoneOTP`, { "phone": phone }
    )
  }
}


